import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Messages from './Messages';
import s from './HistoryParametersFilterbox.css';

class HistoryParametersFilterbox extends React.Component {
  setFilter = (name, deviceType) => {
    this.props.setDeviceDocumentFilter('parameters', name, deviceType);
  };

  setColumnFilter = (name, deviceType) => {
    this.props.setDeviceDocumentColumnFilter('parameters', name, deviceType);
  };

  getElement = (item, index, deviceType, filter) => {
    const value = filter.get(item.name);
    const checked = +value === 1;
    return (
      <div key={index}>
        <input
          type="checkbox"
          name={item.name}
          value={value}
          onChange={this.setFilter.bind(this, item.name, deviceType)}
          checked={checked}
        />
        <label htmlFor={item.name}>
          <FormattedMessage {...item.text} />
        </label>
      </div>
    );
  };

  getColumnHeader = (item, index, deviceType, filter) => {
    const value = filter.get(item.name);
    const checked = +value === 1;
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        return (
          <th className={cx(s.header)} key={index}>
            <input
              type="checkbox"
              name={item.name}
              value={value}
              onChange={this.setColumnFilter.bind(this, item.name, deviceType)}
              checked={checked}
            />
            <FormattedMessage {...item.text} />
          </th>
        );
      case 'superior':
        return (
          <th className={cx(s.spirotech)} key={index}>
            <input
              type="checkbox"
              name={item.name}
              value={value}
              onChange={this.setColumnFilter.bind(this, item.name, deviceType)}
              checked={checked}
            />
            <FormattedMessage {...item.text} />
          </th>
        );
      default:
        break;
    }
    return null;
  };

  getColumn = (column, index, deviceType, columnStyle, filter) => {
    return (
      <td key={index} className={columnStyle}>
        <span>
          {column.map((item, ind) =>
            this.getElement(item, ind, deviceType, filter),
          )}
        </span>
      </td>
    );
  };

  getDataSoftener = (softenerFilterDocument, messages) => {
    const data = [
      [
        {
          text: messages.history_parameters_date,
          name: 'date',
        },
        {
          text: messages.history_parameters_time,
          name: 'time',
        },
        {
          text: messages.history_parameters_language,
          name: 'language',
        },
        {
          text: messages.history_parameters_unit_water_hardness,
          name: 'unit_water_hardness',
        },
        {
          text: messages.history_parameters_water_pressure,
          name: 'water_pressure',
        },
        {
          text: messages.history_parameters_pressure_sensor,
          name: 'pressure_sensor',
        },
        {
          text: messages.history_parameters_chlorine_generator,
          name: 'chlorine_generator',
        },
        {
          text: messages.history_parameters_reserve_period,
          name: 'reserve_period',
        },
      ],
      [
        {
          text: messages.history_parameters_reg_period,
          name: 'reg_period',
        },
        {
          text: messages.history_parameters_days_of_regeneration,
          name: 'days_of_regeneration',
        },
        {
          text: messages.history_parameters_outlet_water_hardness,
          name: 'outlet_water_hardness',
        },
        {
          text: messages.history_parameters_intlet_water_hardness,
          name: 'intlet_water_hardness',
        },
        {
          text: messages.history_parameters_regenerant_dose,
          name: 'regenerant_dose',
        },
        {
          text: messages.history_parameters_resin_volume,
          name: 'resin_volume',
        },
        {
          text: messages.history_parameters_reserve_type,
          name: 'reserve_type',
        },
      ],
      [
        {
          text: messages.history_parameters_percentage_of_reserve,
          name: 'percentage_of_reserve',
        },
        {
          text: messages.history_parameters_regeneration_time,
          name: 'regeneration_time',
        },
        {
          text: messages.history_parameters_average_water_used,
          name: 'average_water_used',
        },
        {
          text: messages.history_parameters_ferrum_content,
          name: 'ferrum_content',
        },
        {
          text: messages.history_parameters_type_of_regeneration,
          name: 'type_of_regeneration',
        },
        {
          text: messages.history_parameters_cancel_vacation_mode,
          name: 'cancel_vacation_mode',
        },
      ],
      [
        {
          text: messages.history_parameters_backwash,
          name: 'backwash',
        },
        {
          text: messages.history_parameters_rapid_rinsing,
          name: 'rapid_rinsing',
        },
        {
          text: messages.history_parameters_dhcp_client,
          name: 'dhcp_client',
        },
        {
          text: messages.history_parameters_ip_address,
          name: 'ip_address',
        },
        {
          text: messages.history_parameters_subnet_mask,
          name: 'subnet_mask',
        },
        {
          text: messages.history_parameters_default_gateway,
          name: 'default_gateway',
        },
        {
          text: messages.history_parameters_dns_server,
          name: 'dns_server',
        },
        {
          text: messages.history_parameters_timezone,
          name: 'timezone',
        },
        {
          text: messages.history_parameters_device_type,
          name: 'device_type',
        },
      ],
    ];
    return data;
  };

  getDataSuperior = (superiorFilterDocument, messages) => {
    const data = [
      [
        {
          text: messages.history_parameters_superior_date,
          name: 'date',
        },
        {
          text: messages.history_parameters_superior_time,
          name: 'time',
        },
        {
          text: messages.history_parameters_superior_language,
          name: 'language',
        },
        {
          text: messages.history_parameters_superior_device_type,
          name: 'device_type',
        },
      ],
      [
        {
          text: messages.history_parameters_superior_auto_degass_start_1_enable,
          name: 'auto_degass_start_1_enable',
        },
        {
          text: messages.history_parameters_superior_auto_degass_start_1_hour,
          name: 'auto_degass_start_1_hour',
        },
        {
          text: messages.history_parameters_superior_auto_degass_start_1_minute,
          name: 'auto_degass_start_1_minute',
        },
        {
          text: messages.history_parameters_superior_auto_degass_stop_1_enable,
          name: 'auto_degass_stop_1_enable',
        },
        {
          text: messages.history_parameters_superior_auto_degass_stop_1_hour,
          name: 'auto_degass_stop_1_hour',
        },
        {
          text: messages.history_parameters_superior_auto_degass_stop_1_minute,
          name: 'auto_degass_stop_1_minute',
        },
      ],
      [
        {
          text: messages.history_parameters_superior_auto_degass_start_2_enable,
          name: 'auto_degass_start_2_enable',
        },
        {
          text: messages.history_parameters_superior_auto_degass_start_2_hour,
          name: 'auto_degass_start_2_hour',
        },
        {
          text: messages.history_parameters_superior_auto_degass_start_2_minute,
          name: 'auto_degass_start_2_minute',
        },
        {
          text: messages.history_parameters_superior_auto_degass_stop_2_enable,
          name: 'auto_degass_stop_2_enable',
        },
        {
          text: messages.history_parameters_superior_auto_degass_stop_2_hour,
          name: 'auto_degass_stop_2_hour',
        },
        {
          text: messages.history_parameters_superior_auto_degass_stop_2_minute,
          name: 'auto_degass_stop_2_minute',
        },
      ],
      [
        {
          text: messages.history_parameters_superior_degass_block,
          name: 'degass_block',
        },
      ],
    ];
    return data;
  };

  getData = (messages, deviceType) => {
    const { documentSoftenerFilter, documentSuperiorFilter } = this.props;
    let data = [];
    let filter = null;
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        data = this.getDataSoftener(documentSoftenerFilter, messages);
        filter = documentSoftenerFilter;
        break;
      case 'superior':
        data = this.getDataSuperior(documentSuperiorFilter, messages);
        filter = documentSuperiorFilter;
        break;
      default:
        break;
    }
    return { data, filter };
  };

  getHeaderData = (messages, deviceType) => {
    let data = [];
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        data = [
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters0',
          },
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters1',
          },
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters2',
          },
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters3',
          },
        ];
        break;
      case 'superior':
        data = [
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters0',
          },
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters1',
          },
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters2',
          },
          {
            text: messages.history_parameters_check_uncheck_all,
            name: 'parameters3',
          },
        ];
        break;
      default:
        break;
    }
    return data;
  };

  getColumnStyle = deviceType => {
    let columnStyle = cx();
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        columnStyle = cx(s.column_softener, s.table_border);
        break;
      case 'superior':
        columnStyle = cx(s.column_superior, s.table_border);
        break;
      default:
        break;
    }
    return columnStyle;
  };

  render() {
    const messages = Messages();
    const { deviceDocument } = this.props;
    const deviceType = deviceDocument.get('deviceType');
    const { data, filter } = this.getData(messages, deviceType);
    const columnStyle = this.getColumnStyle(deviceType);
    const headerData = this.getHeaderData(messages, deviceType);

    return (
      <table className={s.Table_container}>
        <thead>
          <tr>
            {headerData.map((item, index) =>
              this.getColumnHeader(item, index, deviceType, filter),
            )}
          </tr>
        </thead>
        <tbody>
          <tr>
            {data.map((item, index) =>
              this.getColumn(item, index, deviceType, columnStyle, filter),
            )}
          </tr>
        </tbody>
      </table>
    )
  }
}

HistoryParametersFilterbox.propTypes = {
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  setDeviceDocumentFilter: PropTypes.func.isRequired,
  setDeviceDocumentColumnFilter: PropTypes.func.isRequired,
};

export default withStyles(s)(HistoryParametersFilterbox);


// WEBPACK FOOTER //
// ./src/components/HistoryParameters/HistoryParametersFilterboxView.js